




































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";
import { checkLicense } from "../../utils/general-functions";
import { Language } from "../../services/language/entities/language.interface";
import { Translate } from "../../services/language/entities/translate.interface";
import constants from "../../config/constants";

@Component
export default class CreateLicenseDialog extends Vue {
  @Prop() dialogCreate!: boolean;
  @Prop() product!: any;
  @Prop() page!: number;

  cost = null;
  unmaskedCost = null;
  money: any = {
    unmaskedVar: "unmaskedCost"
  };
  term = null;
  quantity = null;
  generalRules = [rules.notEmpty];
  costRules = [rules.notZeroCost];
  name: Array<Translate> = [];

  $refs!: {
    formCreate: HTMLFormElement;
  };

  valid = true;
  loadingCreate = false;
  snackbarSuccessCreate = false;
  snackbarErrorCreate = false;
  snackbarError2Create = false;

  private cancelCreate(): void {
    this.$emit("cancelCreate");
  }

  private createLicense(): void {
    if (checkLicense(this.product.licenses, this.term, this.quantity, false)) {
      this.loadingCreate = true;
      this.$store
        .dispatch("product/addLicenseToProduct", {
          productId: this.product.productID,
          equipments: this.quantity,
          cost: this.unmaskedCost,
          term: this.term,
          start:
            this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
          quantity: constants.ITEMS_PER_PAGE
        })
        .then((response: boolean) => {
          if (response) {
            this.snackbarError2Create = false;
            this.snackbarSuccessCreate = true;
          } else {
            this.snackbarErrorCreate = true;
          }

          this.loadingCreate = false;
          this.cancelCreate();
        });
    } else {
      this.snackbarError2Create = true;
    }
  }

  private get languages(): Array<Language> {
    return this.$store.getters["language/getLanguages"];
  }
}
